module.exports = __webpack_public_path__ + "05_short_yellow.dbd376c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/05_short_yellow.png
// module id = 15ck
// module chunks = 0